import React from 'react'
import {
	GaugeColumn,
	GaugeCount,
	GaugeFill,
	GaugeLabel,
	GaugeTrack,
	RateLimitPanel,
	StateParagraph,
	StrongAccent,
} from '../ItineraryImportPage.styles'
import { formatRetryAfter, MAX_IMPORTS_PER_TRIP_PER_DAY } from '../utils'
import CenteredState from './CenteredState'
import { ClockGlyph } from './icons'

interface RateLimitBodyProps {
	retryAfterSeconds: number
}

const RateLimitBody: React.FC<RateLimitBodyProps> = ({ retryAfterSeconds }) => (
	<CenteredState
		tone="blue"
		icon={<ClockGlyph size={40} strokeWidth={1.8} />}
		headline="You've imported a lot today"
	>
		<StateParagraph>
			This trip has hit today's import limit ({MAX_IMPORTS_PER_TRIP_PER_DAY}). It resets as older
			imports roll out of the 24-hour window — about{' '}
			<StrongAccent>{formatRetryAfter(retryAfterSeconds)}</StrongAccent> from now.
		</StateParagraph>
		<RateLimitPanel>
			<GaugeColumn>
				<GaugeLabel>
					Today's imports on this trip
				</GaugeLabel>
				<GaugeTrack>
					<GaugeFill $pct={100} />
				</GaugeTrack>
			</GaugeColumn>
			<GaugeCount>
				{MAX_IMPORTS_PER_TRIP_PER_DAY} / {MAX_IMPORTS_PER_TRIP_PER_DAY}
			</GaugeCount>
		</RateLimitPanel>
	</CenteredState>
)

export default RateLimitBody
